import { ChakraProvider } from "@chakra-ui/react";
import React from "react";
import ReactDOM from "react-dom/client";
import { MemoryRouter } from "react-router-dom";
import { RecoilRoot } from "recoil";
import App from "./App";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <MemoryRouter initialEntries={[`/${window.location.search}`]}>
    <RecoilRoot>
      <ChakraProvider>
        <App />
      </ChakraProvider>
    </RecoilRoot>
  </MemoryRouter>
);

// Helper function to extract the base domain (e.g., "lipad.io" from "dashboard.lipad.io")
const getBaseDomain = (url) => {
  try {
    const { hostname } = new URL(url);
    const parts = hostname.split(".");
    return parts.length <= 2
      ? hostname
      : parts.slice(parts.length - 2).join(".");
  } catch (error) {
    console.error("Error parsing URL:", error);
    return url;
  }
};

const getApiDomain = () => {
  const origin =
    typeof window !== "undefined" && window.location.origin
      ? window.location.origin
      : "";
  const hostname =
    typeof window !== "undefined" && window.location.hostname
      ? window.location.hostname
      : "";

  if (hostname === "localhost" || origin.includes("localhost")) {
    return "https://sandbox.api.gateway.lipad.io";
  }

  const regex = /^((sandbox|dev)\.)?checkout\.(.+)$/;
  const match = regex.exec(hostname);

  if (match) {
    const envPrefix = match[2] ? `${match[2]}.` : "";
    const domainPart = match[3]; // e.g., "lipad.io" or "kasapay.com"
    return `https://${envPrefix}api.gateway.${domainPart}`;
  }

  const baseDomain = getBaseDomain(origin);
  return `https://api.gateway.${baseDomain}`;
};

const domain = getApiDomain();

export async function checkServerStatus() {
  try {
    const response = await fetch(`${domain}/v1/status`);
    const data = await response.json();
    return {
      isUp: response.ok,
      status: data.status,
      message: data.message,
      ip: data.ip,
    };
  } catch (error) {
    return {
      isUp: false,
      status: null,
      message: "Failed to connect to server",
      ip: null,
    };
  }
}
